import React, { useContext, useEffect, useState } from 'react';
import {
  Input,
  Table,
  Row,
  Col,
  Card,
  Button,
  Image,
  Tag,
  Popconfirm,
  Switch
} from 'antd';
import { PageHeader } from '@ant-design/pro-components';
import ImageViewModal from 'components/Imageviewmodal/Imageviewmodal';
import { ColumnsType } from 'antd/lib/table';
import { SorterResult, TablePaginationConfig } from 'antd/lib/table/interface';
import { IimageStateType, IPart, IRegion, ISubModel, Itrim } from 'types';
import { observer } from 'mobx-react';
import { rootContext } from 'stores';
import { IgetPartParams } from 'services/parts';
import { useDebouncedCallback } from 'use-debounce';
import { RouteConfigs } from 'config/routes';
import { set, get } from 'services/localStorage';
import { capitalize, sortOrderType } from 'common/utils';
import SvgRenderer from 'components/Svgrendere/Svgrendere';
import {
  DeleteFilled,
  EditFilled,
  QuestionCircleOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Submodels from 'components/Submodels/Submodels';
import PartVersion from 'components/PartVersion';
export type IFilterType = {
  [key: string]: string | null;
};

const Parts: React.FC = observer(() => {
  const {
    PartsStore: {
      state: { data, ui },
      getParts,
      setState,
      state,
      deletePart,
      toogleSwitch,
      getVersions
    }
  } = useContext(rootContext);

  const navigate = useNavigate();

  const [search, setSearch] = useState<string>(get({ key: 'searchStr' }) || '');
  const [imageModal, setImageModal] = useState<IimageStateType>({
    alt: '',
    src: '',
    visible: false
  });

  const { parts, page, total, ...storeParams } = data;

  const renderTags = (value: ISubModel[], row: IPart) => {
    return value?.length < 1 ? (
      <Button
        onClick={() =>
          setState({
            data: { ...data, subModelModal: row, selectedSubmodel: null }
          })
        }
      >
        Add Sub Models
      </Button>
    ) : (
      value?.map(item => (
        <div
          className="subModelContainer"
          onClick={() => {
            setState({
              data: { ...data, subModelModal: row } //selectedSubmodel: item }
            });
          }}
        >
          <Tag>{item.submodel}</Tag>
          <div className="tableImage">
            <img src={item?.url || ''} alt={row.name} />
          </div>
        </div>
      ))
    );
  };

  const columns: ColumnsType<IPart> = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: true
    },
    {
      title: 'Brand',
      dataIndex: ['Brand.brand'],
      key: 'brand',

      render: value => capitalize(value)
    },
    {
      title: 'Region',
      dataIndex: 'region',
      key: 'region',

      render: (value: IRegion[]) =>
        value.map((item: IRegion) => <Tag>{item.name}</Tag>)
    },
    {
      title: 'Model',
      dataIndex: 'model',
      key: 'model',
      render: (item: string, value: IPart) => (
        <>
          <div className="subModelContainer">
            <Tag>{item}</Tag>
            {value?.model_image && (
              <div className="tableImage">
                <Image src={value.model_image} alt={value.model_image} />
              </div>
            )}
          </div>
        </>
      ),
      sorter: true
    },
    {
      title: 'Submodels',
      dataIndex: 'submodel',
      key: 'submodel',
      render: renderTags
    },
    {
      title: 'Trims',
      dataIndex: 'series',
      key: 'series',
      render: (value: ISubModel[], row) => {
        let trimsArray: Itrim[] = [];
        row?.submodel?.forEach(sub => {
          sub?.trim?.forEach(t => {
            trimsArray.push(t);
          });
        });
        return trimsArray?.length < 1 ? (
          <Tag> No Trims </Tag>
        ) : (
          trimsArray?.map(item => (
            <div className="subModelContainer">
              <Tag>{item.name}</Tag>
              <div className="tableImage">
                <img src={item.image} alt={item.name} />
              </div>
            </div>
          ))
        );
      }
    },
    {
      title: 'Pattern Type',
      align: 'center',
      dataIndex: 'pattern_type',
      key: 'pattern_type',
      render: value => value,
      sorter: true
    },
    {
      title: 'Start Year',
      align: 'center',
      dataIndex: 'startMakingYear',
      key: 'startMakingYear',
      render: value => value,
      sorter: true
    },
    {
      title: 'End Year',
      align: 'center',
      dataIndex: 'endMakingYear',
      key: 'endMakingYear',
      render: value => value,
      sorter: true
    },
    {
      title: 'Verified',
      align: 'center',
      dataIndex: 'is_verified',
      key: 'is_verified',
      sorter: true,
      render: (value: boolean, record) => (
        <Switch
          checked={value}
          onChange={(v, e) => {
            toogleSwitch({
              id: record.id,
              bool: v,
              key: 'is_verified'
            });
            e.stopPropagation();
          }}
        />
      )
    },
    {
      title: 'Edge Wrapped',
      align: 'center',
      dataIndex: 'is_edge_wrapped',
      key: 'is_edge_wrapped',
      sorter: true,
      render: (value: boolean, record) => (
        <Switch
          checked={value}
          onChange={(v, e) => {
            toogleSwitch({
              id: record.id,
              bool: v,
              key: 'is_edge_wrapped'
            });
          }}
        />
      )
    },
    {
      title: 'Part',
      align: 'center',
      dataIndex: 'url',
      key: 'file',
      render: (value, row: IPart) =>
        value ? (
          <SvgRenderer svgUrl={value} id={uuidv4()} title="View Part" />
        ) : (
          'No File'
        )
    },
    {
      title: 'Part Versions',
      align: 'center',
      dataIndex: 'versions',
      key: 'versions',
      render: (value, row: IPart) => (
        <Button onClick={() => getVersions(row.id, row.part_key)}>
          Versions
        </Button>
      )
    },
    {
      title: 'Actions',
      align: 'center',
      render: (value, record: IPart, index: number) => (
        <div className="actionButtons">
          <Button
            type="default"
            className="editButton"
            onClick={() => {
              setState({ data: { ...state.data, editPart: record } });
              navigate(RouteConfigs.editpart.path);
            }}
          >
            <EditFilled />
          </Button>
          <Popconfirm
            title="Are you sure？"
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            onConfirm={async () => {
              await deletePart({ id: record.id });
              getParts(
                {
                  ...storeParams,
                  search
                },
                page
              );
            }}
          >
            <Button
              type="default"
              className="deleteButton"
              loading={ui.deleteLoading === record.id}
            >
              <DeleteFilled />
            </Button>
          </Popconfirm>
        </div>
      )
    }
  ];

  const getPartsAPIDebounce = useDebouncedCallback(() => { getParsApi({}); }, 1000);

  useEffect(() => {
    getPartsAPIDebounce();
  }, [getPartsAPIDebounce, search]);

  const getColumns = (columns: ColumnsType<IPart>): ColumnsType<IPart> => {
    const { sortBy, sortField } = data;
    return columns.map(item => {
      if (item.key === sortField) {
        item.sortOrder =
          sortBy === 'desc' ? 'descend' : sortBy === 'asc' ? 'ascend' : null;
      }
      return item;
    });
  };

  const getParsApi = (params: Partial<IgetPartParams>, page = 1) => {
    getParts(
      {
        ...storeParams,
        ...params,
        search
      },
      page
    );
  };

  return (
    <div className="PartsStyles">
      <div className="cardWrapeer">
        <Submodels />
        <PartVersion />
        <Card>
          <ImageViewModal
            {...imageModal}
            onClose={() => setImageModal({ alt: '', src: '', visible: false })}
          />
          <PageHeader>
            <Row justify="space-between">
              <Col>
                <Input.Search
                  className="search_input_control"
                  loading={ui.getPartsLoading}
                  allowClear
                  value={search}
                  onChange={e => {
                    setSearch(e.target.value);
                    set({ key: 'searchStr', value: e.target.value });
                  }}
                  placeholder="Search"
                />
              </Col>
              <Col>
                <Button
                  onClick={() => navigate(RouteConfigs.addpart?.path)}
                  type="link"
                  className="primary_btn"
                >
                  Add Part
                </Button>
              </Col>
            </Row>
          </PageHeader>
          <Table
            className="Table_block_main"
            columns={getColumns(columns)}
            loading={ui.getPartsLoading}
            dataSource={parts}
            tableLayout="auto"
            rowKey="id"
            onChange={(pagination, _, sort) => {
              pagination = pagination as TablePaginationConfig;
              const { current = 1, pageSize = 10 } = pagination;

              sort = sort as SorterResult<IPart>;
              const order = sort?.order && sortOrderType(sort.order);
              const field = sort.field as string;
              getParsApi(
                {
                  limit: pageSize,
                  sortBy: order && field ? order : undefined,
                  sortField: order && field ? field : undefined
                },
                current
              );
            }}
            pagination={{
              disabled: ui.getPartsLoading,
              total: total,
              pageSize: data.limit,
              current: data.page,
              showSizeChanger: true,
              pageSizeOptions: ['10', '15', '20']
            }}
          />
        </Card>
      </div>
    </div>
  );
});

export default Parts;
